import {Component,Inject} from 'ng-metadata/core';

@Component({
    selector: 'prm-static-page',
    template : `<prm-static [section]="$ctrl.section"></prm-static>`,
})

export class PrmStaticPage{
    private section: string;

    constructor(@Inject('$stateParams') private $stateParams:angular.ui.IStateParamsService) {
        this.section = $stateParams['section'];
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/static/staticPage.ts